<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    max-width="450px"
  >
      <v-card light>
        <div style = "position: absolute; right: 0; padding-top: 10px;">
            <v-btn
              class="mx-2"
              icon
              title="Close Form"
              @click="handleDialogClose"
            >
              <v-icon class="material-icons-round">
                close
              </v-icon>
            </v-btn>
          </div>
      <v-card-title>
        <span>
            <v-icon style = "font-size: 38px; color: #3576C2" class="material-icons-round">error_outline</v-icon>
        </span>
        <p class = "UpiText">UPI transfers are limited to <strong>₹99,990.00</strong> per day.</p>
        <p class = "warningText" >Please choose Netbanking or Bank Transfer for higher amounts or transfer using UPI in batches.</p>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'upiWarningDialog',
    props: {
        showUPIDialog: Boolean
    },
    data () {
        return {
            dialog: this.showUPIDialog
        }
    },
    methods: {
        handleDialogClose () {
            this.$emit('closeDialog')
        }
    }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
  line-height: 24px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.UpiText {
    font-size: 20px;
    font-weight: 500;
    color: #3576C2;
    padding-top: 8px;
    text-align: center;
}
.warningText {
    font-size: 15px;
    font-weight: 500;
    color: #8c8c8c;
    padding-top: 8px;
    text-align: center;
}
.dialog-custom {
  background: #ffffff;
  border: 1px solid #b9b9bb !important;
  box-sizing: border-box !important;
  border-radius: 21px !important;

  .v-card__actions {
    padding: 20px !important;
  }
}

.v-text-field .v-label {
  font-weight: bold !important;
}
.dialog-header-custom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.custom-btn-common {
  width: 150px;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;
}

.custom-btn {
  background-color: #ffcb05 !important;
  font-size: 14px;
  text-transform: none;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;

  .v-icon {
    font-size: 14px;
    margin-left: 16px;
  }
}
</style>
